import { z } from 'zod';

// DataTable writes namespaced URL keys (e.g. `${tableId}_sort`, `${tableId}_q`,
// `${tableId}_<column>_filter`). They aren't enumerable up front, so routes
// hand them through via catchall instead of declaring each one.
const tableStateValue = z.union([z.string(), z.number()]).optional();

export function dataTableSearchSchema<Shape extends z.ZodRawShape>(shape: Shape) {
  return z.object(shape).catchall(tableStateValue);
}
